<!-- 建筑区域添加组 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			{{ title }}
		</template>
		<div style="padding-top: 30px;">
			<div class="formContainer">
				<label><span class="required">*</span>组名称</label>
				<input type="text" v-model.trim="name" placeholder="请输入组名称" />
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: {
			
		},
		data() {
			return {
				title: '',
				callback: undefined,
				name: ''
			}
		},
		computed: {
			
		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if(this.name == '' || this.name == undefined){
					return
				}
				if(this.callback != undefined){
					this.callback(this.name)
					this.name = ''
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.name = ''
				this.$refs.body.hide()
			},
			open(title, callBack) {
				this.title = title
				this.callback = callBack
				this.$refs.body.open()
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		margin-bottom: 12px;
	}
	
	.formContainer>label{
		min-width: 72px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}
	
	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}
	
	.required{
		color: red;
	}
</style>